const digitalGlossaryUrl = '/science-glossary/';

export default digitalGlossaryUrl;
